module.exports = __webpack_public_path__ + "img/mobilehardwareOpen8.a557d542.png";